import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  return (
    <main className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About C.U Fredson Nigeria</h1>
          <p>Engineering Excellence Since Registration in 2016</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>Who We Are</h2>
              <p>
                C.U Fredson Nigeria Limited is registered under the Companies and Allied Matters Act of 1990 and is a fully integrated Engineering Technology Company committed to providing innovative solutions to peculiar Geological, Environmental, and Construction needs across Nigeria.
              </p>
              <p>
                We specialize in integrating advanced technological solutions across construction, mining, and drilling sectors to improve efficiency, safety, and sustainability.
              </p>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <img src="/images/Fredsonimg 3.jpg" alt="C.U Fredson drilling equipment at work" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section ceo-section">
        <div className="container">
          <div className="ceo-card">
            <div className="ceo-image-wrap">
              <img src="/images/Engr Alfred.jpeg" alt="Engr. Alfred Michael" className="ceo-image" />
            </div>
            <div className="ceo-content">
              <p className="ceo-label">Leadership</p>
              <h2>Engr. Alfred Michael</h2>
              <h3>C.U Fredson CEO &amp; Founder</h3>
              <p>
                Alfred is a philanthropist, diligent, God fearing, humble and astute businessman with a multiethnic background. Michael was born on the 27th of May 1980 in the largest city in Africa, Ibadan in Oyo State, Nigeria.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: 'var(--light-color)' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '40px' }}>Our Mission & Vision</h2>
          <div className="mission-vision-grid">
            <div className="mission-card">
              <h3>Our Mission</h3>
              <p>
                To integrate cutting-edge technological solutions into the construction, mining, and drilling industries to improve efficiency, reduce costs, enhance collaboration, and deliver higher quality projects while maintaining the highest safety and environmental standards.
              </p>
            </div>
            <div className="vision-card">
              <h3>Our Vision</h3>
              <p>
                To be the leading Engineering Technology Company in Nigeria, recognized for innovation, reliability, safety, and excellence in delivering comprehensive solutions for geological, environmental, and construction challenges.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '60px' }}>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Safety</h3>
              <p>We prioritize the safety of our team, clients, and communities in every operation, adhering strictly to all regulatory standards.</p>
            </div>
            <div className="value-card">
              <h3>Excellence</h3>
              <p>We are committed to delivering the highest quality services with precision, attention to detail, and professional expertise in all projects.</p>
            </div>
            <div className="value-card">
              <h3>Innovation</h3>
              <p>We continuously integrate advanced technologies and innovative solutions to improve efficiency and deliver better results.</p>
            </div>
            <div className="value-card">
              <h3>Sustainability</h3>
              <p>We are committed to environmental responsibility and sustainable practices in all our operations and projects.</p>
            </div>
            <div className="value-card">
              <h3>Integrity</h3>
              <p>We operate with honesty, transparency, and professionalism in all our business dealings and client relationships.</p>
            </div>
            <div className="value-card">
              <h3>Collaboration</h3>
              <p>We believe in teamwork and collaboration with clients, partners, and stakeholders to achieve mutual success.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: 'var(--light-color)' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '40px' }}>Company Highlights</h2>
          <div className="highlights-grid">
            <div className="highlight">
              <h4>Fully Integrated Services</h4>
              <p>From construction technology to mining support and rock drilling, we provide comprehensive solutions under one roof.</p>
            </div>
            <div className="highlight">
              <h4>Expert Team</h4>
              <p>Our team comprises highly trained professionals with extensive experience in engineering, construction, and mining industries.</p>
            </div>
            <div className="highlight">
              <h4>Advanced Technology</h4>
              <p>We invest in cutting-edge technology and equipment to ensure efficient, safe, and sustainable operations.</p>
            </div>
            <div className="highlight">
              <h4>Regulatory Compliance</h4>
              <p>We strictly adhere to all Nigerian and international safety, environmental, and regulatory standards in our operations.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Interested in Working with Us?</h2>
          <p>Whether you have a project in mind or want to learn more about our services, we'd love to hear from you.</p>
          <Link to="/contact" className="btn btn-light">Contact Us Today</Link>
        </div>
      </section>
    </main>
  );
}

export default About;
